import { Component, Input, OnInit } from "@angular/core";
import { DataService_ViewSection } from "../shared/data.service";

@Component({
	selector: "caass-student-details",
	templateUrl: "./student-details.component.html",
	styleUrls: ["./student-details.component.css"],
})
export class StudentDetailsComponent implements OnInit {
	constructor(private ViewSectionService: DataService_ViewSection) {}

	ngOnInit(): void {
		if (this.SectionID != -1) {
			this.loadStudent();
		} else {
			this.lstStudent = [];
		}
	}

	ngOnChanges() {
		if (this.SectionID != -1) {
			this.loadStudent();
		} else {
			this.lstStudent = [];
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SectionID: any = -1;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStudent: any;
	lstStudent: any = [];

	//Filter lists
	lstStatusDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
		{ field: "Advisor", header: "Counselor" },
		{ field: "StatusDesc", header: "Active" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStudent() {
		this.loading = true;

		var result = this.ViewSectionService.LoadStudents(this.SectionID);
		result.subscribe(
			(response) => {
				this.lstStudent = response;

				// for(var i = 0; i < this.lstStudent.length; i++){
				//   var next = this.lstStudent[i];

				//   next.StatusDesc = next.Active == 1 ? "Active" : "Inactive"
				// }

				//Load Data Filter Lists
				this.lstStatusDesc = Array.from(new Set(this.lstStudent.map((item: any) => item.StatusDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStudent = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStudent = null;
	}
	////////////////////////////////////////////
}
